import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/long-arrow-down.svg';
import _imports_1 from '@/assets/images/icons/link.svg';
import _imports_2 from '@/assets/images/icons/loading.svg';
import _imports_3 from '@/assets/images/icons/open.svg';
const _withScopeId = n => (_pushScopeId("data-v-475934ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mt-4"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "font-size": "13px"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center",
  style: {
    "margin-top": "-8px",
    "margin-bottom": "-8px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "down-class"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "20px"
  },
  alt: ""
})], -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "16px"
  },
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "d-flex justify-content-center",
  style: {
    "margin-top": "-8px",
    "margin-bottom": "-8px"
  }
};
const _hoisted_10 = {
  key: 0,
  class: "down-class"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  key: 1,
  class: "down-class"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading-load",
  src: _imports_2,
  style: {
    "width": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "d-flex align-items-center"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {
    "width": "18px"
  },
  alt: ""
}, null, -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  key: 0,
  class: "err-tip"
};
const _hoisted_20 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_21 = {
  class: "link-text",
  style: {
    "text-decoration": "underline",
    "color": "rgb(77, 56, 0)"
  },
  target: "_blank",
  href: "https://docs.filecoin.io/smart-contracts/filecoin-evm-runtime/differences-with-ethereum/#bare-value-sends"
};
const _hoisted_22 = {
  key: 2,
  class: "mt-3"
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = {
  key: 3,
  class: "mt-3"
};
const _hoisted_25 = {
  class: "mt-3"
};
const _hoisted_26 = {
  key: 0,
  class: "err-tip"
};
const _hoisted_27 = {
  class: "mt-3 d-flex align-items-center"
};
const _hoisted_28 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
const _hoisted_29 = {
  class: "mt-3 d-flex align-items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TransferRadioBtn = _resolveComponent("TransferRadioBtn");
  const _component_transfer_input = _resolveComponent("transfer-input");
  const _component_evm_tip = _resolveComponent("evm-tip");
  const _component_el_button = _resolveComponent("el-button");
  const _component_TransferSTFIL = _resolveComponent("TransferSTFIL");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_TransferRadioBtn, {
    "tab-arr": $data.radioOptions,
    modelValue: $data.form.token,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.token = $event)
  }, null, 8, ["tab-arr", "modelValue"])]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_transfer_input, {
    disabled: true,
    title: _ctx.$t('transfer.from'),
    id: "1",
    modelValue: $data.form.from,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.from = $event),
    type: "textarea",
    valueFontSize: "20px"
  }, {
    subTitle: _withCtx(() => [!$options.isEmpty(_ctx.f1Address) ? (_openBlock(), _createElementBlock("p", _hoisted_2, "f1: " + _toDisplayString($options.simpleValue(_ctx.f1Address, 6, 6)), 1)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["title", "modelValue"])]), _withDirectives(_createElementVNode("div", null, [$data.showFilForwarder ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), $data.showFilForwarder ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_transfer_input, {
    style: {
      "background-color": "rgba(237,237,237,0.3)"
    },
    disabled: true,
    modelValue: _ctx.simpleContractAddress,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.simpleContractAddress = $event),
    title: _ctx.$t('transfer.To FilForwarder'),
    id: "5",
    type: "textarea",
    valueFontSize: "16px",
    valueFontColor: "rgb(113,113,113)"
  }, {
    subTitle: _withCtx(() => [_createElementVNode("span", {
      onClick: _cache[2] || (_cache[2] = (...args) => $options.openFilforwader && $options.openFilforwader(...args)),
      style: {
        "transform": "translateY(-1px)"
      },
      target: "_blank",
      class: "icon-hover mr-2"
    }, _toDisplayString(_ctx.$t('stake.LearnMore')), 1)]),
    suffix: _withCtx(() => [_createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = $event => $options.gotoAdr($data.filForwarderContracts)),
      style: {
        "transform": "translateY(-1px)"
      },
      class: "icon-hover mr-2 cursor-pointer"
    }, _hoisted_8)]),
    _: 1
  }, 8, ["modelValue", "title"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [!$data.checkAddressLoading ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)) : _createCommentVNode("", true), $data.checkAddressLoading ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_transfer_input, {
    ref: "transfer-textarea",
    modelValue: $data.form.to,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.to = $event),
    onInput: $options.toAddressChangeWait,
    title: _ctx.$t('transfer.to'),
    id: "2",
    disabled: $data.loading,
    placeholder: "0x f0 f1 f2 f3 f4",
    type: "textarea",
    showValueTip: $data.formToEthAddress !== '',
    "value-tip": $data.formToEthAddress,
    valueFontSize: "20px"
  }, {
    subTitle: _withCtx(() => [_createElementVNode("div", _hoisted_16, [$data.formFinish.to ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "mr-2",
      onClick: _cache[5] || (_cache[5] = $event => $options.gotoAdr($data.form.to))
    }, _hoisted_18)) : _createCommentVNode("", true), $data.form.to !== '' && $data.form.to.length > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "icon-hover",
      onClick: _cache[6] || (_cache[6] = (...args) => $options.clearInputTo && $options.clearInputTo(...args))
    }, _toDisplayString(_ctx.$t('common.clear')), 1)) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue", "onInput", "title", "disabled", "showValueTip", "value-tip"]), $data.toErrTips !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($data.toErrTips), 1)) : _createCommentVNode("", true), $data.isEvm ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_evm_tip, null, {
    content: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("transfer.contractTipContent")), 1), _createElementVNode("a", _hoisted_21, _toDisplayString(_ctx.$t("stake.LearnMore")), 1)]),
    _: 1
  })])) : $data.form.eth !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_evm_tip, null, {
    content: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('transfer.transfer0XTip')
    }, null, 8, _hoisted_23)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.showFilForwarder ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_evm_tip, null, {
    content: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("transfer.transferForwardTip")), 1)]),
    _: 1
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_transfer_input, {
    title: _ctx.$t('transfer.amount'),
    onInput: $options.amountChange,
    modelValue: $data.form.amount,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.amount = $event),
    type: "number",
    disabled: $data.loading,
    placeholder: "0.00",
    showValueTip: $data.showAmountUsd,
    valueTip: `≈ $${$data.amountUsd}`
  }, {
    subTitle: _withCtx(() => [_createElementVNode("span", {
      onClick: _cache[8] || (_cache[8] = (...args) => $options.setAmountIsBalance && $options.setAmountIsBalance(...args)),
      class: "icon-hover"
    }, _toDisplayString(`${_ctx.$t('transfer.balance')}: ${$data.form.token === 'FIL' ? $options.formatWalletFilPrice(_ctx.filBalance, 2, false) : $options.formatWalletFilPrice(_ctx.stFilBalance, 2, true)}`), 1)]),
    _: 1
  }, 8, ["title", "onInput", "modelValue", "disabled", "showValueTip", "valueTip"]), $data.amountErrTips !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString($data.amountErrTips), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_button, {
    disabled: !_ctx.ifAllFinishSend,
    class: "btn btn-primary w-100 i-button",
    loading: $data.loading,
    style: {
      "border-radius": "50px!important"
    },
    onClick: $options.send
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('transfer.send')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("img", {
    onClick: _cache[10] || (_cache[10] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_1,
    alt: ""
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
    class: "btn btn-outline-clear w-100 i-button",
    style: {
      "border-radius": "50px!important"
    },
    disabled: $data.loading,
    onClick: $options.clearInput
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('transfer.clear')), 1)]),
    _: 1
  }, 8, ["disabled", "onClick"])])], 512), [[_vShow, $data.form.token === 'FIL']]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_TransferSTFIL, {
    "coin-type": "stfil",
    "contract-address": $data.stFilContractAddress,
    "contract-f0-address": $data.stFilContractF0Address,
    "contract-abi": $data.stFilContractABI
  }, null, 8, ["contract-address", "contract-f0-address", "contract-abi"])], 512), [[_vShow, $data.form.token === 'stFIL']]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_TransferSTFIL, {
    "coin-type": "wstfil",
    "contract-address": $data.wstFilContractAddress,
    "contract-f0-address": $data.wstFilContractF0Address,
    "contract-abi": $data.wstFilContractABI
  }, null, 8, ["contract-address", "contract-f0-address", "contract-abi"])], 512), [[_vShow, $data.form.token === 'wstFIL']])])]);
}